import { newGuid } from '@opten/common/new-guid';

export function getOrSetRandomId(node: Element) {
	let id = node.getAttribute('id');
	if (!id) {
		id = newGuid();
		node.setAttribute('id', id);
	}
	return id;
}
